module.exports = __webpack_public_path__ + "static/media/solidityLogo.279907e3.png";